import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function SobreNosotros() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section ref={ref} className={`w-full bg-secondary-50 py-16 md:py-20 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left: Image */}
          <div className="w-full lg:w-1/2">
            <div className="w-full h-[340px] md:h-[420px] lg:h-[480px] rounded-[28px] overflow-hidden relative">
              <img
                src="/images/021-about-toldero-malaga.webp"
                alt="Toldero profesional en Málaga reparando un toldo"
                title="Toldero profesional en Málaga"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="w-full lg:w-1/2 flex flex-col gap-5">
            <span className="inline-flex px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-semibold font-label tracking-wide w-fit">
              Tolderos en Málaga desde 2010
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              Cuidamos tu terraza<br />como si fuera la nuestra
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed max-w-lg">
              Somos un equipo de tolderos locales que conoce bien el clima de Málaga: el sol fuerte del verano, el viento de levante y el salitre de la costa que castiga lonas y mecanismos. Por eso, cada reparación e instalación que hacemos está pensada para durar.
            </p>
            <p className="text-base text-foreground-600 leading-relaxed max-w-lg">
              No somos una tienda de toldos. Somos un servicio técnico de confianza: diagnosticamos, reparamos e instalamos con precisión. Trabajamos con todas las marcas y modelos, y damos garantía por escrito en cada intervención.
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 pt-3">
              <Link
                to="/contacto"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
              >
                <span>Conócenos</span>
                <i className="ri-arrow-right-up-line text-base"></i>
              </Link>
              <a
                href="https://wa.me/34627213347"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm font-semibold text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-lg"></i>
                <span>Hablar por WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}